module.exports = __webpack_public_path__ + "img/logo-menu.e05576eb.png";